export function getHeaderValue(headers, headerName) {
    return headers && headerName && headers[headerName];
}
//# sourceMappingURL=getHeaderValue.js.map